import type { Material, MeshPhysicalMaterial, Texture } from '@seddi/three';
import { textureMapsKeys } from './textureTypes';

// Return a new material with the same parameters as this material
export const clone = (material: MeshPhysicalMaterial): MeshPhysicalMaterial => {
  const materialCopy = material.clone();
  // Three Material clone does not copy defines.
  materialCopy.defines = material.defines;

  if (!material.map) {
    return materialCopy;
  }

  // create shallow clones of the Texture object, which shares the same image data but allows for individual modification of texture properties
  for (const key of textureMapsKeys) {
    const texture = material[key] as Texture;
    if (!texture) {
      continue;
    }
    const textureCopy = texture.clone();
    textureCopy.needsUpdate = true;
    materialCopy[key] = textureCopy;
  }

  return materialCopy;
};

/**
 * @deprecated Find UV scale map.
 * @param material Material
 */
export const findUvScaleMap = (material: Material): Texture | undefined => {
  // WebGLMaterials.js
  // uv repeat and offset setting priorities
  // 1. color map
  // 2. specular map
  // 3. displacementMap map
  // 4. normal map
  // 5. bump map
  // 6. roughnessMap map
  // 7. metalnessMap map
  // 8. alphaMap map
  // 9. emissiveMap map
  // 10. clearcoat map
  // 11. clearcoat normal map
  // 12. clearcoat roughnessMap map

  const _material = material as any;

  if (_material.map) {
    return _material.map;
  } else if (_material.specularMap) {
    return _material.specularMap;
  } else if (_material.displacementMap) {
    return _material.displacementMap;
  } else if (_material.normalMap) {
    return _material.normalMap;
  } else if (_material.bumpMap) {
    return _material.bumpMap;
  } else if (_material.roughnessMap) {
    return _material.roughnessMap;
  } else if (_material.metalnessMap) {
    return _material.metalnessMap;
  } else if (_material.alphaMap) {
    return _material.alphaMap;
  } else if (_material.emissiveMap) {
    return _material.emissiveMap;
  } else if (_material.clearcoatMap) {
    return _material.clearcoatMap;
  } else if (_material.clearcoatNormalMap) {
    return _material.clearcoatNormalMap;
  } else if (_material.clearcoatRoughnessMap) {
    return _material.clearcoatRoughnessMap;
  }

  return undefined;
};
